import { call, put, takeEvery } from "redux-saga/effects";

import { PaginateQuery, ResponseGenerator } from "../../interfaces";
import {
  ADD_FLASH_CARD,
  AddFlashCardAction,
  DELETE_FLASH_CARD,
  DeleteFlashCardAction,
  GET_FLASH_CARD,
  GetFlashCardAction,
  GetFlashCardsAction,
  UPDATE_FLASH_CARD,
  UpdateFlashCardAction,
  GET_FLASH_CARDS,
  UPLOAD_FLASH_CARD_IMAGE,
  GET_FLASH_CARDS_BY_LESSON,
  GetFlashCardsByLessonAction,
  UploadFlashCardImageAction,
  DeleteAllFlashCardAction,
  DELETE_ALL_FLASH_CARD,
  ToggleFlashCardStateAction,
  TOGGLE_FLASH_CARD_STATE,
  UPLOAD_AND_CREATE_FLASH_CARD,
  UploadAndCreateFlashCardAction,
} from "./actionTypes";
import {
  addFlashCardError,
  addFlashCardSuccess,
  deleteAllFlashCardError,
  deleteAllFlashCardSuccess,
  deleteFlashCardError,
  deleteFlashCardSuccess,
  getFlashCardError,
  getFlashCardSuccess,
  getFlashCardsByLessonError,
  getFlashCardsByLessonSuccess,
  getFlashCardsError,
  getFlashCardsSuccess,
  toggleFlashCardStateError,
  toggleFlashCardStateSuccess,
  updateFlashCardError,
  updateFlashCardSuccess,
  uploadAndCreateFlashCardError,
  uploadAndCreateFlashCardSuccess,
  uploadFlashCardImageError,
  uploadFlashCardImageSuccess,
} from "./actions";
import {
  addFlashCard,
  deleteAllFlashCardByLessonId,
  deleteFlashCard,
  getFlashCard,
  getFlashCards,
  getFlashCardsByLesson,
  toggleFlashCardState,
  updateFlashCard,
  uploadAndCreateFlashCard,
  uploadFlashCardImage,
} from "../../helpers/backend_helper";

function* getFlashCardsSaga({
  payload: { request, history },
}: GetFlashCardsAction) {
  try {
    const response: ResponseGenerator = yield call(
      getFlashCards,
      request as PaginateQuery
    );
    yield put(getFlashCardsSuccess(response.data));
  } catch (error) {
    yield put(getFlashCardsError(error));
  }
}

function* getFlashCardsByLessonSaga({
  payload: { lessonId, history },
}: GetFlashCardsByLessonAction) {
  try {
    const response: ResponseGenerator = yield call(
      getFlashCardsByLesson,
      lessonId
    );
    yield put(getFlashCardsByLessonSuccess(response.data));
  } catch (error) {
    yield put(getFlashCardsByLessonError(error));
  }
}

function* getFlashCardSaga({ payload: { id, history } }: GetFlashCardAction) {
  try {
    const response: ResponseGenerator = yield call(getFlashCard, id);
    yield put(getFlashCardSuccess(response.data));
  } catch (error) {
    yield put(getFlashCardError(error));
  }
}

function* addFlashCardSaga({
  payload: { request, history },
}: AddFlashCardAction) {
  try {
    const response: ResponseGenerator = yield call(addFlashCard, request);
    yield put(addFlashCardSuccess(response.data));
  } catch (error) {
    yield put(addFlashCardError(error));
  }
}

function* updateFlashCardSaga({
  payload: { id, request, history },
}: UpdateFlashCardAction) {
  try {
    const response: ResponseGenerator = yield call(
      updateFlashCard,
      id,
      request
    );
    yield put(updateFlashCardSuccess(response.data));
  } catch (error) {
    yield put(updateFlashCardError(error));
  }
}

function* deleteFlashCardSaga({
  payload: { id, history },
}: DeleteFlashCardAction) {
  try {
    yield call(deleteFlashCard, id);
    yield put(deleteFlashCardSuccess(id));
  } catch (error) {
    yield put(deleteFlashCardError(error));
  }
}

function* uploadFlashCardImageSaga({
  payload: { file, history, flashCardId },
}: UploadFlashCardImageAction) {
  try {
    const response: ResponseGenerator = yield call(
      uploadFlashCardImage,
      file,
      flashCardId
    );
    yield put(uploadFlashCardImageSuccess(response.data));
  } catch (error) {
    yield put(uploadFlashCardImageError(error));
  }
}

function* deleteAllFlashCardSaga({
  payload: { lessonId, history },
}: DeleteAllFlashCardAction) {
  try {
    yield call(deleteAllFlashCardByLessonId, lessonId);
    yield put(deleteAllFlashCardSuccess(lessonId));
  } catch (error) {
    yield put(deleteAllFlashCardError(error));
  }
}

function* toggleFlashCardStateSaga({
  payload: { id, history },
}: ToggleFlashCardStateAction) {
  try {
    yield call(toggleFlashCardState, id);
    yield put(toggleFlashCardStateSuccess(id));
  } catch (error) {
    yield put(toggleFlashCardStateError(error));
  }
}

function* uploadAndCreateFlashCardSaga({
  payload: request,
}: UploadAndCreateFlashCardAction) {
  try {
    const response: ResponseGenerator = yield call(
      uploadAndCreateFlashCard,
      request
    );
    yield put(uploadAndCreateFlashCardSuccess(response.data));
  } catch (error) {
    yield put(
      uploadAndCreateFlashCardError({
        error,
        localId: request.localId as number,
      })
    );
  }
}

function* FlashCardSaga() {
  yield takeEvery(GET_FLASH_CARDS, getFlashCardsSaga);
  yield takeEvery(GET_FLASH_CARDS_BY_LESSON, getFlashCardsByLessonSaga);
  yield takeEvery(GET_FLASH_CARD, getFlashCardSaga);
  yield takeEvery(ADD_FLASH_CARD, addFlashCardSaga);
  yield takeEvery(UPDATE_FLASH_CARD, updateFlashCardSaga);
  yield takeEvery(DELETE_FLASH_CARD, deleteFlashCardSaga);
  yield takeEvery(UPLOAD_FLASH_CARD_IMAGE, uploadFlashCardImageSaga);
  yield takeEvery(DELETE_ALL_FLASH_CARD, deleteAllFlashCardSaga);
  yield takeEvery(TOGGLE_FLASH_CARD_STATE, toggleFlashCardStateSaga);
  yield takeEvery(UPLOAD_AND_CREATE_FLASH_CARD, uploadAndCreateFlashCardSaga);
}

export default FlashCardSaga;
